// extracted by mini-css-extract-plugin
export var accountNav = "side-panel-module--account-nav--f-Dos";
export var closeButton = "side-panel-module--close-button--wdbS4";
export var footer = "side-panel-module--footer--dFnx7";
export var header = "side-panel-module--header---bxQI";
export var navItem = "side-panel-module--nav-item--UXvql";
export var navItemActive = "side-panel-module--nav-item-active--80Zst";
export var navItemLogout = "side-panel-module--nav-item--logout--8kZyb";
export var panel = "side-panel-module--panel--WET6C";
export var panelAdmin = "side-panel-module--panel--admin--E-wUp";
export var panelNav = "side-panel-module--panel-nav--i3B6F";
export var panelNav__avatarWrapper = "side-panel-module--panel-nav__avatar-wrapper--zeK5c";
export var panelNav__btn = "side-panel-module--panel-nav__btn--VAXw8";
export var panelNav__btnActive = "side-panel-module--panel-nav__btn--active--iRa6N";
export var panelNav__separator = "side-panel-module--panel-nav__separator--rgv4m";
export var panel__contentWrapper = "side-panel-module--panel__content-wrapper--SDNMS";
export var userCard = "side-panel-module--user-card--iGhqZ";
export var userCardAvatar = "side-panel-module--user-card-avatar--RuPDp";
export var userCardAvatarImg = "side-panel-module--user-card-avatar-img--JI3aq";
export var userCardButton = "side-panel-module--user-card-button--ZSv7n";
export var userCardDescription = "side-panel-module--user-card-description--y-9Ow";
export var userCardTitle = "side-panel-module--user-card-title--zsVPR";
export var userCardWrapper = "side-panel-module--user-card-wrapper--8jo9n";